import {integerFormatter, numberFormatter} from "../../gridFormatters";
import { wtAvg } from "../../math";

export const freeSpaceByDeviceDefs = [
    {
        "field": "device_name",
        "headerName": "Device Name"
    },
    {
        "field": "data_center",
        "headerName": "Data Center",
        "enableRowGroup": true,
    },
    {
        "field": "classification",
        "headerName": "Classification",
        "enableRowGroup": true,
    },
    {
        "field": "device_type_description",
        "headerName": "Type",
        "filter": "agSetColumnFilter",
        "enableRowGroup": true
    },
    {
        "field": "total_allocated",
        "type": "numericColumn",
        "headerName": "Allocated",
        "filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
    },
    {
        "field": "total_free",
        "type": "numericColumn",
        "headerName": "Free",
        "filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
    },
    {
        "field": "largest_contiguous_free",
        "type": "numericColumn",
        "headerName": "Largest Contiguous Free",
        "filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
    },
    {
        "field": "num_disk_groups",
        "headerName": "Pools",
        "type": "numericColumn",
        "cellRenderer": integerFormatter,
        "enableValue": true,
        "aggFunc": "sum",
        "filter": "agNumberColumnFilter",
    },
    {
        "field": "dedupe_gb",
        "headerName": "Savings",
        "type": "numericColumn",
        "enableValue": true,
        "aggFunc": "sum",
        "filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
    },
    {
        "field": "num_drives",
        "headerName": "# Drives",
        "type": "numericColumn",
        "cellRenderer": integerFormatter,
        "enableValue": true,
        "aggFunc": "sum",
        "filter": "agNumberColumnFilter",
    },
    {
        "field": "iops",
        "headerName": "IOPS",
        "type": "numericColumn",
        "enableValue": true,
        "aggFunc": "sum",
        "filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
    },
    {
        "field": "latency",
        "headerName": "Latency",
        "type": "numericColumn",
        "enableValue": true,
        "aggFunc": (params) => wtAvg(params, "latency", "iops"),
        "filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
    },
    {
        "field": "total_used",
        "type": "numericColumn",
        "headerName": "Used",
        "filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
    },
    {
        "field": "usable_gb",
        "type": "numericColumn",
        "headerName": "Usable",
        "filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
    }
];
export const freeSpaceByDeviceTypeDefs = [
    {
        "field": "device_type_description",
        "headerName": "Type",
        "filter": "agSetColumnFilter",
        "enableRowGroup": true
    },
    {
        "field": "total_allocated",
        "type": "numericColumn",
        "headerName": "Allocated",
        "filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
    },
    {
        "field": "total_free",
        "type": "numericColumn",
        "headerName": "Free",
        "filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
    },
    {
        "field": "largest_contiguous_free",
        "type": "numericColumn",
        "headerName": "Largest Contiguous Free",
        "filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
    },
    {
        "field": "num_disk_groups",
        "headerName": "Pools",
        "type": "numericColumn",
        "cellRenderer": integerFormatter,
        "enableValue": true,
        "aggFunc": "sum",
        "filter": "agNumberColumnFilter",
    },
    {
        "field": "dedupe_gb",
        "headerName": "Savings",
        "type": "numericColumn",
        "enableValue": true,
        "aggFunc": "sum",
        "filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
    },
    {
        "field": "num_drives",
        "headerName": "# Drives",
        "type": "numericColumn",
        "cellRenderer": integerFormatter,
        "enableValue": true,
        "aggFunc": "sum",
        "filter": "agNumberColumnFilter",
    },
    {
        "field": "iops",
        "headerName": "IOPS",
        "type": "numericColumn",
        "enableValue": true,
        "aggFunc": "sum",
        "filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
    },
    {
        "field": "latency",
        "headerName": "Latency",
        "type": "numericColumn",
        "enableValue": true,
        "aggFunc": (params) => wtAvg(params, "latency", "iops"),
        "filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
    },
    {
        "field": "total_used",
        "type": "numericColumn",
        "headerName": "Used",
        "filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
    },
    {
        "field": "usable_gb",
        "type": "numericColumn",
        "headerName": "Usable",
        "filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
    }
];
export const freeSpaceByClassificationDefs = [
    {
        "field": "classification",
        "headerName": "Classification",
        "enableRowGroup": true,
    },
    {
        "field": "total_allocated",
        "type": "numericColumn",
        "headerName": "Allocated",
        "filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
    },
    {
        "field": "total_free",
        "type": "numericColumn",
        "headerName": "Free",
        "filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
    },
    {
        "field": "largest_contiguous_free",
        "type": "numericColumn",
        "headerName": "Largest Contiguous Free",
        "filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
    },
    {
        "field": "num_disk_groups",
        "headerName": "Pools",
        "type": "numericColumn",
        "cellRenderer": integerFormatter,
        "enableValue": true,
        "aggFunc": "sum",
        "filter": "agNumberColumnFilter",
    },
    {
        "field": "dedupe_gb",
        "headerName": "Savings",
        "type": "numericColumn",
        "enableValue": true,
        "aggFunc": "sum",
        "filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
    },
    {
        "field": "num_drives",
        "headerName": "# Drives",
        "type": "numericColumn",
        "cellRenderer": integerFormatter,
        "enableValue": true,
        "aggFunc": "sum",
        "filter": "agNumberColumnFilter",
    },
    {
        "field": "iops",
        "headerName": "IOPS",
        "type": "numericColumn",
        "enableValue": true,
        "aggFunc": "sum",
        "filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
    },
    {
        "field": "latency",
        "headerName": "Latency",
        "type": "numericColumn",
        "enableValue": true,
        "aggFunc": (params) => wtAvg(params, "latency", "iops"),
        "filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
    },
    {
        "field": "total_used",
        "type": "numericColumn",
        "headerName": "Used",
        "filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
    },
    {
        "field": "usable_gb",
        "type": "numericColumn",
        "headerName": "Usable",
        "filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
    }
];
export const freeSpaceByDataCenterDefs = [
    {
        "field": "data_center",
        "headerName": "Data Center",
        "enableRowGroup": true,
    },
    {
        "field": "total_allocated",
        "type": "numericColumn",
        "headerName": "Allocated",
        "filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
    },
    {
        "field": "total_free",
        "type": "numericColumn",
        "headerName": "Free",
        "filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
    },
    {
        "field": "largest_contiguous_free",
        "type": "numericColumn",
        "headerName": "Largest Contiguous Free",
        "filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
    },
    {
        "field": "num_disk_groups",
        "headerName": "Pools",
        "type": "numericColumn",
        "cellRenderer": integerFormatter,
        "enableValue": true,
        "aggFunc": "sum",
        "filter": "agNumberColumnFilter",
    },
    {
        "field": "dedupe_gb",
        "headerName": "Savings",
        "type": "numericColumn",
        "enableValue": true,
        "aggFunc": "sum",
        "filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
    },
    {
        "field": "num_drives",
        "headerName": "# Drives",
        "type": "numericColumn",
        "cellRenderer": integerFormatter,
        "enableValue": true,
        "aggFunc": "sum",
        "filter": "agNumberColumnFilter",
    },
    {
        "field": "iops",
        "headerName": "IOPS",
        "type": "numericColumn",
        "enableValue": true,
        "aggFunc": "sum",
        "filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
    },
    {
        "field": "latency",
        "headerName": "Latency",
        "type": "numericColumn",
        "enableValue": true,
        "aggFunc": (params) => wtAvg(params, "latency", "iops"),
        "filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
    },
    {
        "field": "total_used",
        "type": "numericColumn",
        "headerName": "Used",
        "filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
    },
    {
        "field": "usable_gb",
        "type": "numericColumn",
        "headerName": "Usable",
        "filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
    }
];